<template>
  <layout-default-filters @open="$_OnOpen" @apply="$_applyQueryString" :hideButton="filtroInicial">
    <template #superior>
      <div class='div-geral'>
        
        <div class='primeiro-filtro'>
          <v-form ref="form">
            <div style="height: 50px;"></div>
          </v-form>
        </div>

        <div class='segundo-filtro'>
          
          <div v-if="filtroAtivo === null">
            <core-text-field
              clearable class='txt-filter'
              @focus="ativarFiltro('veiculo')"
              v-model="termoBusca"
              label='Veículo / Placa'
            />
          </div>

          <div v-if="filtroAtivo === 'veiculo'">
            <div class='radios' :class="{ 'visible': filtroAtivo === 'veiculo' }">
              <v-radio-group v-model="radioCampo" hide-details class="mt-0">
                <v-row dense>
                  <v-col cols="6" class="py-0">
                    <v-radio label="Placa" :value="1"></v-radio> 
                  </v-col>
                  <v-col cols="6" class="py-0 pb-3">
                    <v-radio label="Descrição / Modelo" :value="2"></v-radio> 
                  </v-col>
                </v-row>
              </v-radio-group>
            </div>

            <core-text-field
              clearable class='txt-filter'
              @focus="ativarFiltro('veiculo')"
              @keyup.enter="$_load(1)" 
              v-model="termoBusca"
              label='Pesquisar Veículo...'
            />
            
            <div class='btns-wrap' :class="{ 'visible': filtroAtivo === 'veiculo' }">
              <v-btn rounded color='primary' class='btns' @click='$_load(0)'>
                <v-icon>mdi-arrow-left-thick</v-icon>
              </v-btn>
              <v-btn rounded color='primary' class='btns reducesize' @click='$_load(1)'>
                <v-icon>mdi-arrow-left-thick</v-icon><v-icon>mdi-arrow-right-thick</v-icon>
              </v-btn>
              <v-btn rounded color='primary' class='btns-mini' @click='$_load(2)'>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>

            <template v-if="filtroAtivo === 'veiculo'">
              <v-divider></v-divider>
              <div class="mx-auto cardlist" max-width="500">
                
                <div v-if="loading" class="text-center pa-4">
                  <v-progress-circular indeterminate color="primary" size="24"></v-progress-circular>
                </div>

                <v-list two-line class='scroll' v-else>
                  <v-list-item-group active-class="green--text" multiple>
                    <template v-for="(item, index) in itemsVeiculo">
                      <v-list-item :key="(item.veiidveiculo || index) + '-' + index">
                        <v-card class='cardpessoa' @click="$_onClickCard(item.veiplaca || item.veidescricao, item.veiidveiculo)">
                          <div style="height: 100%; display: flex; align-items: center; padding-left: 16px;">
                            <span class="font-weight-medium">{{ item.veiplaca }} - {{ item.veidescricao }}</span>
                          </div>
                        </v-card>
                      </v-list-item>
                      <v-divider v-if="index < itemsVeiculo.length - 1" :key="index"></v-divider>
                    </template>
                    
                    <v-list-item v-if="itemsVeiculo.length === 0 && termoBusca">
                      <v-list-item-content>
                        <v-list-item-title class="text-center grey--text">Nenhum veículo encontrado.</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </div>
              <v-divider></v-divider>
            </template>
          </div>
          
        </div>
      </div>
    </template>
  </layout-default-filters>
</template>

<script>
import { mapMutations } from 'vuex';
import db from '@/plugins/dexie';
import { getQueryValue, setQueryValue } from '@/services/query-string';
import LayoutDefaultFilters from '@/layouts/default/NewFilters.vue';
import CoreTextField from '@/components/core/text-field/Index.vue';
import errorHandler from '@/utils/error-handler';
import storage from '@/services/storage';

const STORAGE_KEY_TEXTO_VEICULO = 'filtro_veiculo_texto';

export default {
  name: 'ViewPesquisaVeiculoFilters',

  components: {
    LayoutDefaultFilters,
    CoreTextField,
  },

  data() {
    return {
      filtroAtivo: null,
      filtroInicial: false,
      loading: false,

      itemsVeiculo: [],
      radioCampo: 1, // 1 = Placa, 2 = Descrição

      termoBusca: null,
      buscaTimeout: null,

      filters: {
        idveiculo: null,
      },
    };
  },

  methods: {
    ...mapMutations({
      $_setRefresh: 'filter/refresh',
    }),

    removerAcentos(texto) {
      if (!texto) return '';
      return texto.toString().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
    },

    ativarFiltro(nomeFiltro) {
      this.filtroAtivo = nomeFiltro;
      if (!this.filtroInicial) {
        this.subirForm(true);
      }

      if (this.termoBusca) {
        this.$_load(1);
      }
    },

    async $_load(parametroLoad) {
      if (parametroLoad === 2) {
        this.termoBusca = null;
        this.filters.idveiculo = null;
        storage.setItem(STORAGE_KEY_TEXTO_VEICULO, '');
        this.$_applyQueryString();
        
        this.itemsVeiculo = [];
        this.subirForm(0);
        this.loading = false;
        return;
      }

      this.loading = true;
      try {
        if (this.filtroAtivo === 'veiculo') {
          const resultadosLocais = await this.buscarNoDexie(parametroLoad);
          this.itemsVeiculo = resultadosLocais || [];
        }
      } catch (err) {
        errorHandler.call(this, err);
      } finally {
        this.loading = false;
      }
    },

    async buscarNoDexie(tipoBusca) {
      if (!this.termoBusca) return [];
      const texto = this.termoBusca.toString().trim();
      if (texto === '') return [];

      const textoLower = this.removerAcentos(texto.toLowerCase());

      try {
        let collection = db.veiculo.toCollection();

        return await collection.filter(v => {
          if (this.radioCampo === 1) { // Placa
            const placa = (v.veiplaca || v.placa || '').toString().toLowerCase().replace(/[^a-z0-9]/g, '');
            const buscaLimpa = textoLower.replace(/[^a-z0-9]/g, '');
            return tipoBusca === 0 ? placa.startsWith(buscaLimpa) : placa.includes(buscaLimpa);
          }
          if (this.radioCampo === 2) { // Descrição
            const desc = (v.veidescricao || v.descricao || '').toString().toLowerCase();
            const descLimpa = this.removerAcentos(desc);
            return tipoBusca === 0 ? descLimpa.startsWith(textoLower) : descLimpa.includes(textoLower);
          }
          return false;
        })
        .limit(50) 
        .toArray();

      } catch (e) {
        console.warn("Erro na query do Dexie:", e);
        return [];
      }
    },

    $_applyQueryString() {
      setQueryValue('busca', null);
      setQueryValue('tipoBusca', null);
      
      if (this.termoBusca) {
        setQueryValue('busca', this.termoBusca);
        setQueryValue('tipoBusca', this.radioCampo === 1 ? 'placa' : 'descricao');
      }
      
      this.$_setRefresh('S');
    },

    $_OnOpen() {
      this.subirForm(false);
    },

    subirForm(bool) {
      if (bool) {
        if (this.filtroInicial) { return; }
        document.querySelector('.primeiro-filtro').style.opacity = '0';
        document.querySelector('.primeiro-filtro').style.zIndex = '-1';
        
        const topValue = '-50px'; 
        document.querySelector('.segundo-filtro').style.top = topValue;
        
        this.filtroInicial = true;
      } else {
        if (!this.filtroInicial) { return; }
        document.querySelector('.primeiro-filtro').style.opacity = '1';
        document.querySelector('.primeiro-filtro').style.zIndex = '2';
        document.querySelector('.segundo-filtro').style.top = '0';
        
        this.filtroInicial = false;
        this.filtroAtivo = null;
      }
    },

    $_onClickCard(nome, idveiculo) {
      if (this.filtroInicial) {
        if (this.filtroAtivo === 'veiculo') {
          this.termoBusca = `${nome}`; 
          storage.setItem(STORAGE_KEY_TEXTO_VEICULO, this.termoBusca);
          this.filters.idveiculo = idveiculo;
        }
        
        this.$_applyQueryString();
        this.subirForm(0);
      }
    },
  },

  watch: {
    radioCampo() {
      this.itemsVeiculo = [];
      if (this.termoBusca) this.$_load(1);
    },
    
    termoBusca(novoValor) {
      if (this.filtroAtivo === 'veiculo') {
        if (novoValor && novoValor.trim() !== '') {
          clearTimeout(this.buscaTimeout);
          this.buscaTimeout = setTimeout(() => {
            this.$_load(1);
          }, 300);
        } else {
          this.itemsVeiculo = [];
        }
      }
    },

    $route: {
      deep: true,
      immediate: true,
      async handler() {
        const busca = getQueryValue('busca', null);

        if (busca) { 
          this.termoBusca = busca;
        } else {
          const valorSalvo = await storage.getItem(STORAGE_KEY_TEXTO_VEICULO);
          this.termoBusca = (typeof valorSalvo === 'string') ? valorSalvo : null;
        }
      },
    },
  },
};
</script>

<style scoped>
  .div-geral { height: 0%; }
  .btns-wrap { display: flex; justify-content: space-around; height: 50px; transition: opacity 0.3s; opacity: 0; }
  .btns { width: 33%; transition: opacity 0.3s; }
  .btns.reducesize { width: 33%; }
  .btns-mini { width: 10%; transition: opacity 0.3s; }
  .primeiro-filtro { transition: opacity 0.3s; position: relative; opacity: 1; z-index: 1; }
  .segundo-filtro { transition: top 0.4s; position: relative; z-index: 1; height: 0px; }
  .radios { transition: opacity 0.3s; opacity: 0; height: auto; }
  .radios.visible, .btns-wrap.visible { opacity: 1; }
  .mx-auto.cardlist { transition: opacity 0.3s, top 0.4s; height: 50vh; overflow-y: scroll; background-color: rgb(245, 245, 245); }
  .cardpessoa { height: 60px; width: 100%; margin-top: 5px; cursor: pointer; }
  .txt-filter { height: 50px; }
</style>